import { AppSetting } from 'dependencies/appsettings';
import { useRouterHistory } from 'react-router';
import { useHistory } from 'app/area/shared/navigation';
import { syncHistoryWithStore } from 'react-router-redux';
import { browserHistory } from 'react-router';
import { configureSystemImport, getHostingPath } from 'app/infrastructure/hosting';
import { configureStore } from 'app/infrastructure/configure-store';
import { createHistory } from 'history';
import { configure as configureReactHotkeys } from 'react-hotkeys';
import { connectToStore } from 'app/infrastructure/remote-data';

/**
 * Support hosting in virtual directories
 */
export function connectHistoryToRouter(store: any) {

  const baseUrl = getHostingPath();
  let history: any = browserHistory;

  if (baseUrl) {

    // .. and instruct the router to ignore that part when resolving routes
    history = useRouterHistory(createHistory)({basename: baseUrl});
  }

  // save the instance to separate routing concerns
  useHistory(history);

  // configure router to sync with redux store
  return syncHistoryWithStore(history, store);
}

/**
 * Handle dev/prod initialization
 */
export function configureEnvironment(): { store: any, history: any } {

  if (!AppSetting.ApiBaseUrl) {
    // tslint:disable-next-line
    throw new Error(`"ApiBaseUrl" in appsettings.json must be a URL pointing to the correct API endpoint.`);
  }

  configureReactHotkeys({ ignoreTags: [] });

  configureSystemImport();

  const store = configureStore();

  const history = connectHistoryToRouter(store);

  connectToStore(store);

  return { store, history };
}
